import React, { useContext, useMemo, useState } from 'react';
import classNames from 'classnames';
import { DataRoomShareableLink } from 'models/ShareableLink';
import { Button, Loader } from 'ncoded-component-library';
import ResolvePagination from 'components/ResolvePagination';
import { useTranslation } from 'react-i18next';
import ShareableLinksMobileItem from './components/ShareableLinksMobileItem';
import CreateShareableLinkContext from 'router/subrouters/DataRoom/providers/CreateShareableLink/CreateShareableLink.context';
import MultiSortPanel from 'components/MultiSortPanel';
import useMultiSort from 'hooks/useMultiSort';
import {
  SORTING_VALUES,
  SL_SORT_DIRECTION_COPY,
  TABLE_COLUMNS,
} from '../ShareableLinksTable/components/data';

import './ShareableLinksMobile.styles.scss';

const HEADING_TRANSLATIONS: Record<string, string> = {
  name: 'name',
  accessNumber: 'access',
  totalAccessCount: 'visitsUC',
  fileIds: 'files',
  lastAccessDate: 'lastAccess',
  createdAt: 'created',
  linkExpiresDate: 'expiresOn',
};

type ShareableLinksMobileProps = {
  className?: string;
  isLoading: boolean;
  totalPages: number;
  shareableLinks: DataRoomShareableLink[];
  updateShareableLink: (link: DataRoomShareableLink) => void;
  onAfterToggleState?: (linkBeforeToggle: DataRoomShareableLink) => void;
};

const ShareableLinksMobile: React.FC<ShareableLinksMobileProps> = (props) => {
  const {
    className,
    isLoading,
    totalPages,
    shareableLinks,
    updateShareableLink,
    onAfterToggleState,
  } = props;

  const [expandedLinkId, setExpandedLinkId] = useState(null);

  const { openCreateShareableLink } = useContext(CreateShareableLinkContext);

  const loading = useMemo(
    () => isLoading && !shareableLinks?.length,
    [isLoading, shareableLinks?.length],
  );

  const classes = classNames('shareable-links-mobile', { loading }, className);

  const { t } = useTranslation();

  const { multiSortValues, multiSortDirectionTranslation } = useMultiSort(
    TABLE_COLUMNS,
    SORTING_VALUES,
    HEADING_TRANSLATIONS,
    SL_SORT_DIRECTION_COPY,
  );
  return (
    <div className={classes}>
      {loading && <Loader />}

      <div className="shareable-links-mobile__header">
        <Button variant="outline" onClick={() => openCreateShareableLink()}>
          {t('createSecureLink')}
        </Button>
        <MultiSortPanel
          options={multiSortValues}
          sortDirectionTranslations={multiSortDirectionTranslation}
        />
      </div>

      <div className="white-panel">
        {shareableLinks.map((link) => (
          <ShareableLinksMobileItem
            key={link?._id}
            link={link}
            isExpanded={expandedLinkId === link?._id}
            updateShareableLink={updateShareableLink}
            onAfterToggleState={onAfterToggleState}
            onRowClick={({ _id }) =>
              setExpandedLinkId(expandedLinkId === _id ? null : _id)
            }
          />
        ))}
      </div>

      <ResolvePagination totalPages={totalPages} />
    </div>
  );
};

export default ShareableLinksMobile;
